"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _SVGTextStyle = _interopRequireDefault(require("./SVGTextStyle"));

var _SVGWrapper = _interopRequireDefault(require("./SVGWrapper"));

var SVGText = function SVGText(props) {
  var wrapperProps = props.wrapperProps,
      innerProps = (0, _objectWithoutProperties2.default)(props, ["wrapperProps"]);
  return _react.default.createElement(_SVGWrapper.default, wrapperProps, _react.default.createElement(_SVGTextStyle.default, innerProps));
};

SVGText.propTypes = {
  wrapperProps: _propTypes.default.any
};
var _default = SVGText;
exports.default = _default;
module.exports = exports.default;